import { render, staticRenderFns } from "./goodsDispatchDetails.vue?vue&type=template&id=7455e6f8&scoped=true"
import script from "./goodsDispatchDetails.vue?vue&type=script&lang=ts"
export * from "./goodsDispatchDetails.vue?vue&type=script&lang=ts"
import style0 from "./goodsDispatchDetails.vue?vue&type=style&index=0&id=7455e6f8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455e6f8",
  null
  
)

export default component.exports